export function index ()
{
    return axios.get(route('api.manage.companies.competences') + '?limit=9999&include=tags,applicationCompetences,jobCompetences')
        .then(response => response.data);
}

export function indexForJob (jobId)
{
    return axios.get(
        route('api.manage.jobs.competences', {jobId}) + '?include=competences',
        {params: {limit: 9999}})
        .then(response => response.data);
}

export function indexForApplication (applicationId)
{
    return axios.get(
    	route('api.manage.applications.competences', {applicationId}) + '?include=user',
    	{ params: {limit:9999} })
        .then(response => response.data);
}

export function storeCompetenceScore (applicationId, data)
{
    return axios.post(route('api.manage.applications.competences.store', {applicationId}) + '?include=application', data)
        .then(response => response.data);
}

export function updateCompetenceScore (applicationId, data)
{
    return axios.patch(route('api.manage.applications.competences.update', {applicationId}) + '?include=application', data)
        .then(response => response.data);
}

export function deleteCompetenceScore (applicationId, data)
{
    return axios.delete(route('api.manage.applications.competences.destroy', {applicationId}), {data})
        .then(response => response.data);
}

export function destroyForJob (jobId, data)
{
    return axios.delete(route('api.manage.jobs.competences.destroy', {jobId}), {data});
}

export function store (data, include = [])
{
    if (include.length > 0) {
        include = include.join();
    }

    return axios.post(route('api.manage.companies.competences') + '?include=' + include, data)
        .then(response => response.data);
}

export function storeForJob (jobId, data)
{
    return axios.post(route('api.manage.jobs.competences.store', {jobId}), data)
        .then(response => response.data);
}

export function storeForJobBulk (jobId, data)
{
    return axios.post(route('api.manage.jobs.competences.massive', {jobId}), data)
        .then(response => response.data);
}

export function show(competenceId)
{
    return axios.get(route('api.manage.competences.show', { competenceId: competenceId }));
}

export function update(competenceId, data, include = [])
{
    if (include.length > 0) {
        include = include.join();
    }

    return axios.patch(route('api.manage.competences.update', { competenceId: competenceId }) + '?include=' + include, data)
        .then(response => response.data);
}

export function destroy(competenceId)
{
    return axios.delete(route('api.manage.competences.destroy', { competenceId: competenceId }));
}
